import Meta from '@/components/common/Meta'

import AffordableCollegeStorageSolutionsPage from '@/v2/components/pages/landing-pages/affordable-college-storage-solutions-page'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/affordable-college-storage-solutions-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'

interface AffordableCollegeStorageSolutionsPageProps {}

const Page: React.FC<AffordableCollegeStorageSolutionsPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.affordable_college_storage_solutions.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.affordable_college_storage_solutions?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.affordable_college_storage_solutions?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <AffordableCollegeStorageSolutionsPage />
    </>
  )
}

export default Page
